module.exports = __webpack_public_path__ + "img/5.e1d541ff.png";